var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('van-cell',{attrs:{"title":_vm.title}}),_c('div',{staticClass:"video-live-card"},[(_vm.options['sources'].length > 0)?_c('video-player',{attrs:{"options":_vm.options}}):_vm._e()],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }